import { render, staticRenderFns } from "./DiscountViewSidebar.vue?vue&type=template&id=7bff555a&scoped=true&"
import script from "./DiscountViewSidebar.vue?vue&type=script&lang=js&"
export * from "./DiscountViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DiscountViewSidebar.vue?vue&type=style&index=0&id=7bff555a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff555a",
  null
  
)

export default component.exports